import store from '@/store';
import requestAPI from '../requestBeApi';

const singleProjectService = {
  async getSingleProject({ self, projectId }: { self: any; projectId: string }): Promise<void> {
    store.commit('setFetchingSingleProject', true);

    const url = `/api/v1/assessment-requests/${projectId}`;
    const response = await requestAPI({ url, method: 'GET' });

    if (response.ok) {
      this.parseSingleProjectData(response);
    } else if (response.status !== 401) {
      showGenericErrorMsg(self);
    }

    store.commit('setFetchingSingleProject', false);
  },

  async parseSingleProjectData(response: { json: () => any }): Promise<void> {
    const data = await response.json();
    const project = data;
    store.commit('setSingleProject', project);
  },

  async confirmSingleProject({
    self,
    projectId,
  }: {
    self: any;
    projectId: string;
  }): Promise<Response> {
    store.commit('setFetchingSingleProject', true);

    const url = `/api/v1/assessment-requests/${projectId}/accept`;
    const response = await requestAPI({
      url,
      method: 'PATCH',
      contentType: 'application/merge-patch+json',
    });

    if (!response.ok) {
      showGenericErrorMsg(self);
    }

    store.commit('setFetchingSingleProject', false);

    return response;
  },

  async rejectSingleProject({
    self,
    projectId,
    rejectionReason,
    decision,
  }: {
    self: any;
    projectId: string;
    rejectionReason: string;
    decision: 'decline' | 'interested';
  }): Promise<Response> {
    store.commit('setFetchingSingleProject', true);

    const url = `/api/v1/assessment-requests/${projectId}/${decision}`;
    const payload = {
      comment: rejectionReason,
    };

    const response = await requestAPI({
      url,
      method: 'PATCH',
      contentType: 'application/merge-patch+json',
      payload,
    });

    if (!response.ok) showGenericErrorMsg(self);

    store.commit('setFetchingSingleProject', false);

    return response;
  },
};

function showGenericErrorMsg(self: {
  $message: (arg0: { message: string; type: string }) => void;
  $t: (arg0: string) => string;
}) {
  self.$message({
    message: self.$t('someErrorOccurred'),
    type: 'error',
  });
}

export default singleProjectService;
